module.exports = (__webpack_require__(19364))(1230);